import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent {
  @Input() placeholderText: string;
  @Input() autofocus = false;
  @Output() valueChange = new EventEmitter();
  private timeout: any;
  public text: string;
  public isLoading: boolean;

  get isTextSizeValid() {
    return this.text.length > 2;
  }

  public onChange() {
    if (this.isTextSizeValid) {
      this.isLoading = true;
    }

    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      if (this.isTextSizeValid) {
        this.valueChange.emit(this.text.toLowerCase());
      } else {
        this.valueChange.emit('');
      }

      this.isLoading = false;
    }, 500);
  }
}
